import Vue from "vue";
import "element-ui/lib/theme-chalk/index.css";
import {
  Button,
  Row,
  Col,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Tooltip,
  Popover,
  Image,
} from "element-ui";

Vue.use(Button);
Vue.use(Row);
Vue.use(Col);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Tooltip);
Vue.use(Popover);
Vue.use(Image);
